import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const HeroSmall = (props) =>
{
  return (
    <section className="relative bg-gradient-to-r from-black/50 to-gray-900 py-24 lg:py-48">
      <div className="absolute inset-0">
        <GatsbyImage
          image={getImage(props.backgroundHero)!}
          alt={props.alt}
          className="h-full w-full object-cover opacity-80"
        />
      </div>
      <div className="relative mx-auto max-w-screen-lg px-8 text-left">
        <h1 className="mb-6 text-4xl font-extrabold leading-tight md:text-5xl text-white">
          {props.title}
        </h1>
        {props.subtitle && (
          <p className="mb-8 text-lg md:text-xl text-white">{props.subtitle}</p>
        )}
        {props.children}
      </div>
    </section>
  )
}

export const HeroSmallFragment = graphql`
  fragment HeroSmallFragment on File {
    name
    childImageSharp {
      gatsbyImageData(
        quality: 100
        placeholder: DOMINANT_COLOR
        layout: FULL_WIDTH
      )
    }
  }
`

export default HeroSmall
